import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '@environments/environment';

export interface FeedbackData {
  learningId: string;
  content: string;
  rating: number;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  constructor(private http: HttpClient) {}

  submitFeedback(feedbackData: FeedbackData): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/learning/feedback`, feedbackData).pipe(
      map((response) => {
        return response;
      }),
      catchError((error) => {
        return of(error);
      })
    );
  }
}
